import { createMuiTheme, Theme } from '@material-ui/core/styles';
import { selectLocale } from 'models/localization';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const fontFamilyByLocale = {
  'zh-Hans': 'Noto Sans SC',
  'zh-Hant': 'Noto Sans TC',
  ja: 'Noto Sans JP',
};

const useDefaultTheme = (): Theme => {
  const locale = useSelector(selectLocale);

  return useMemo(() => createMuiTheme({
    typography: {
      fontFamily: [
        fontFamilyByLocale[locale] ?? 'Lato',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  }), [locale]);
};

export default useDefaultTheme;
